(() => {
  const initializeStickyCart = (footer) => {
    const bar = footer?.querySelector('[data-ct-sticky-cart]');
    const checkout = footer?.querySelector('#checkout');
    const price = bar?.querySelector('[data-ct-sticky-cart-total]');
    if (!bar || !checkout || bar.dataset.initialized === 'true') return;

    bar.dataset.initialized = 'true';
    let checkoutIsVisible = false;

    const updateVisibility = () => {
      const cartIsEmpty = footer.classList.contains('is-empty') || checkout.disabled;
      const shouldShow = !cartIsEmpty && !checkoutIsVisible;
      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    const syncFromFooter = () => {
      const currentPrice = footer.querySelector('.totals__total-value');
      const nextPrice = currentPrice?.textContent.trim();
      if (price && nextPrice && price.textContent.trim() !== nextPrice) {
        price.textContent = nextPrice;
      }
      updateVisibility();
    };

    const observer = new IntersectionObserver(([entry]) => {
      checkoutIsVisible = entry.isIntersecting;
      updateVisibility();
    }, { rootMargin: '0px', threshold: 0 });

    observer.observe(checkout);

    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        syncFromFooter();
      });
    }

    syncFromFooter();
  };

  const initialize = () => initializeStickyCart(document.getElementById('main-cart-footer'));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
